import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewParentInterviewComponent } from '../../../../components/review-content/review-parent-interview/review-parent-interview.component';

@Component({
  selector: 'parent-interview-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewParentInterviewComponent
  ],
  templateUrl: './parent-interview-submission.component.html',
  styleUrl: './parent-interview-submission.component.css'
})
export class ParentInterviewSubmissionComponent implements OnInit {
  
  @Input() parentInterviewData: any;
  @Output() onSaveSection13 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.parentInterviewData) {
      this.currentCaseId = this.parentInterviewData.case_id;
    }
  }

  submitParentInterview(): void {
    this.onSaveSection13.emit({});
  }

}
